import { ENDPOINTS, endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createGiftCard = (_, payload) => {
  return Api(ENDPOINTS.GIFT_CARD.CREATE, payload, requestType.POST);
};

const updateGiftCard = (id, payload) => {
  return Api(
    ENDPOINTS.GIFT_CARD.UPDATE.replace(":id", id),
    payload,
    requestType.PUT,
  );
};

const getGiftCardById = (id) => {
  return Api(
    ENDPOINTS.GIFT_CARD.SINGLE.replace(":id", id),
    null,
    requestType.GET,
  );
};

const getGiftCardBySlug = (slug) => {
  return Api(
    ENDPOINTS.GIFT_CARD.SINGLE_BY_SLUG.replace(":slug", slug),
    null,
    requestType.GET,
  );
};

const getGiftCards = (params = {}) => {
  const ENDPOINT = ENDPOINTS.GIFT_CARD.GET;

  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  const finalUrl = queryParams.toString()
    ? `${ENDPOINT}?${queryParams.toString()}`
    : `${ENDPOINT}`;

  return Api(finalUrl, null, requestType.GET);
};

export {
  createGiftCard,
  updateGiftCard,
  getGiftCardById,
  getGiftCardBySlug,
  getGiftCards,
};
